import { useMediaQuery } from "react-responsive";
import { bp } from "../../design/breakpoints";

// Breakpoint values come from the single source of truth in design/breakpoints.js.
// (Values unchanged from before consolidation: desktop >=992, tablet 768-991, mobile <=767.)

export const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: bp.desktopMin });
  return isDesktop ? children : null;
};
export const Tablet = ({ children }) => {
  const isTablet = useMediaQuery({ minWidth: bp.tabletMin, maxWidth: bp.tabletMax });
  return isTablet ? children : null;
};
export const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: bp.mobileMax });
  return isMobile ? children : null;
};
export const Default = ({ children }) => {
  const isNotMobile = useMediaQuery({ minWidth: bp.tabletMin });
  return isNotMobile ? children : null;
};
